export const isMobileDevice = () => {
  // Verificar se está em WebView
  const userAgent = navigator.userAgent.toLowerCase();
  
  // Verificar WebView
  const isWebView = /(wv|webview)/.test(userAgent);

  // Log para debug
  console.log('📱 WebView Detection:', {
    userAgent,
    isWebView,
    platform: navigator.platform,
    vendor: navigator.vendor
  });

  // Retornar true se for WebView
  return isWebView;
}; 